import React from 'react';
import ExternalModal from '../Modals/ExternalModal';

const Footer = () => (
  <footer className="footer full-width">
    <div className="wrapper">
      <div>
        <p>TAKEDA and <img src="/images/endmatter-takeda.svg" alt="TAKEDA" /> are registered trademarks of Takeda Pharmaceutical Company Limited. NINLARO, <img src="/images/endmatter-ninlaro.svg" alt="NINLARO" /> , HERE2ASSIST, and <img src="/images/endmatter-h2a.svg" alt="HERE2ASSIST" /> are registered trademarks of Millennium Pharmaceuticals, Inc. ALUNBRIG,<img src="/images/endmatter-alunbrig.svg" alt="ALUNBRIG" />, ICLUSIG, and <img src="/images/endmatter-iclusig.svg" alt="ICLUSIG" /> are registered trademarks of ARIAD Pharmaceuticals, Inc. FRUZAQLA and <img src="/images/endmatter-fruzaqla.svg" height="16" alt="FRUZAQLA" />are trademarks of HUTCHMED Group Enterprises Limited, used under license. MIMRYLO and <img src="/images/endmatter-mimrylo.svg" alt="MIMRYLO" /> are trademarks of Takeda Pharmaceutical Company Limited.</p>

        <p>&copy;2026 Takeda Pharmaceuticals U.S.A., Inc.</p>
        <p className="m-bottom">All rights reserved. &nbsp;&nbsp;&nbsp;06/26&nbsp;&nbsp;&nbsp; US-XMP-0436</p>

        <p className="m-bottom2">
          <ExternalModal url="https://www.takeda.com/privacy-notice/" trigger={ <a className="track track-2 track-env-global" rel="noopener noreferrer">Privacy Policy</a> }/>
          &nbsp;&nbsp;/&nbsp;&nbsp;<ExternalModal url="https://www.takeda.com/terms-of-use" trigger={ <a className="track track-3 track-env-global" rel="noopener noreferrer">Terms of Use</a> } /></p>

        <p className="m-bottom2">Please note: This resource is for informational purposes only. Information on this site should not be construed as medical advice. The submission and completion of reimbursement- or coverage-related documentation is the responsibility of the patient and the healthcare professional.</p>

        <p>This site is intended for US audiences only.</p>
      </div>
      <img className="logo" src="/images/takeda_oncology_logo.png" alt="Takeda Oncology logo" />
    </div>
  </footer>
);

export default Footer;
